import type { NumRangeLike } from "@tento-core/range";

/** Shared vertical (value) extent for a canvas, when one is imposed. */
export type PlotYExtent = Readonly<{ min: number; max: number }>;

/** Viewport request for materializing plot data. */
export type PlotRequest = Readonly<{
  viewRange: NumRangeLike;
  paddedRange: NumRangeLike;
  /**
   * Canvas-wide y-extent every renderer should map values against, so a
   * single shared price/value scale is used across all series (and can be
   * labelled by a y-axis). `null` falls back to each renderer's own
   * per-series auto extent.
   */
  yExtent: Option<PlotYExtent>;
}>;

export namespace PlotRequest {
  export function make(
    viewRange: NumRangeLike,
    paddedRange: Option<NumRangeLike> = null,
    yExtent: Option<PlotYExtent> = null,
  ): PlotRequest {
    const resolvedPadded = paddedRange ?? viewRange;

    return Object.freeze({
      viewRange: Object.freeze({ ...viewRange }),
      paddedRange: Object.freeze({ ...resolvedPadded }),
      yExtent: yExtent ? Object.freeze({ ...yExtent }) : null,
    });
  }
}
